module.exports = __webpack_public_path__ + "img/41-min.889089c4.jpg";